/** @format */

import { Col, Tooltip } from "antd";
import moment from "moment";
import React from "react";
import styled from "styled-components";
import { UIText } from "../../../ui/Text";

interface Props {
  day: moment.Moment;
  holiday?: string;       // descrizione festività, se presente
  annotations?: string[]; // lista descrizioni annotazioni del giorno
}

const IndexDayBase = ({ day, holiday, annotations }: Props): JSX.Element => {
  const hasInfo = !!holiday || !!annotations?.length;

  // Contenuto del tooltip: festività (se c'è) + annotazioni (se ci sono)
  const tooltipContent = hasInfo ? (
    <div style={{ fontSize: "12px", lineHeight: "1.6" }}>
      {holiday && (
        <div style={{ fontWeight: 700, marginBottom: annotations?.length ? "4px" : 0 }}>
          🎉 {holiday}
        </div>
      )}
      {annotations?.map((a, i) => (
        <div key={i} style={{ opacity: 0.9 }}>
          📌 {a}
        </div>
      ))}
    </div>
  ) : undefined;

  return (
    <Col span={3} className="pipallino" style={{ textAlign: "center" }}>
      <Tooltip title={tooltipContent} placement="top" color="#2a2a2a">
        <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: "2px" }}>
          <UIText
            style={{
              textTransform: "capitalize",
              cursor: hasInfo ? "pointer" : "default",
              fontSize: "15px",
              fontWeight: 500,
              color: holiday ? "#ff4d4f" : "inherit",
            }}
          >
            {moment(day).format("ddd DD")}
          </UIText>

          {/* Indicatori sotto la data: pallino rosso festività + pallino blu annotazioni */}
          {hasInfo && (
            <div style={{ display: "flex", gap: "3px", justifyContent: "center" }}>
              {holiday && (
                <span
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor: "#ff4d4f",
                    display: "inline-block",
                    flexShrink: 0,
                  }}
                />
              )}
              {!!annotations?.length && (
                <span
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor: "#1890ff",
                    display: "inline-block",
                    flexShrink: 0,
                  }}
                />
              )}
            </div>
          )}
        </div>
      </Tooltip>
    </Col>
  );
};

export const IndexDay = styled(IndexDayBase)`
  .pipallino {
    border-left: 1px solid black;
    text-align: left !important;
  }
  .pipallino::last-of-type {
    border-right: 1px solid black;
  }
`;
